import { useEffect, useState } from "react";
import SpecialAnalysis from "../../../api/SpecialAnalysis/SpecialAnalysis";
import SpecialAnalysisFileAttachment from "../../../api/SpecialAnalysis/SpecialAnalysisFileAttachment";
import ViewSpecialAnalysisForm from "./ViewSpecialAnalysisForm";
import BillingInfo from "../../../api/Admin/BillingInfo";
import { useLocation } from 'react-router-dom';

export default function ViewSpecialAnalysis({ formRequestDetailsRef, match }) {
  const specialAnalysisId = match?.params?.id;
  const [mySpecialAnalysis, setMySpecialAnalysis] = useState();
  const [mySpecialAnalysisStatic, setMySpecialAnalysisStatic] = useState();
  const [initialStatus, setInitialStatus] = useState('');
  const [files, setFiles] = useState([]);
  const [billingList, setBillingList] = useState([]);

  const location = useLocation()
  const fromTab = location.state && location.state.tab ? location.state.tab : null

  useEffect(() => {
    SpecialAnalysis.getById(specialAnalysisId).then((result) => {
      if (result) {
        setMySpecialAnalysis(result);
        setMySpecialAnalysisStatic(JSON.parse(JSON.stringify(result)));

        setInitialStatus(result.statusName);
      }
    });
    SpecialAnalysisFileAttachment.getAll(specialAnalysisId).then((res) => {
      setFiles(
        res.map((file) => {
          return {
            file: {
              ...file,
              name: file.fileName,
            },
          };
        })
      );
    });

    BillingInfo.getAll().then((res) => {
      if (res.message === 'Success') {
        setBillingList(res.result.filter(result => result.isActive === true))
      }
    });

  }, [specialAnalysisId]);

  return (
    <div>
      {mySpecialAnalysis && billingList && (
        <ViewSpecialAnalysisForm
          billingList={billingList}
          mySpecialAnalysis={mySpecialAnalysis}
          mySpecialAnalysisStatic={mySpecialAnalysisStatic}
          setMySpecialAnalysis={setMySpecialAnalysis}
          files={files}
          setFiles={setFiles}
          fromTab={fromTab}
          initialStatus={initialStatus}
        />
      )}
    </div>
  );
}
